module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-1@2x-27498820b0cfcc2b8421f822adbc6213.png";